import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SEO } from "../components/SEO";

const AboutPage = () => {
  return (
    <div className="pt-20" data-testid="about-page">
      <SEO
        title="About"
        description="FunAsia Digital — A performance-driven digital marketing agency focused on measurable outcomes: leads, calls, and revenue for local businesses, brands, and franchises."
        path="/about"
      />
      <section className="section-padding bg-gradient-to-br from-orange-light via-white to-white">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="font-display text-4xl md:text-5xl font-bold text-gray-dark mb-4">About FunAsia Digital</h1>
            <p className="text-gray-medium text-lg">SmartReach&trade; · Driving Real Customers To Your Business</p>
          </div>

          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-card">
            <p className="text-lg text-gray-dark mb-6 leading-relaxed">
              FunAsia Digital is a performance-driven digital marketing agency focused on
              <strong className="text-orange-primary"> measurable outcomes</strong>: walk-ins, leads, calls, and revenue.
            </p>
            <p className="text-gray-medium mb-6 leading-relaxed">
              We help local businesses, brands, and franchises grow through SmartReach™ — our proprietary
              platform combining digital advertising, radio, hyperlocal targeting, and dual loyalty rewards.
            </p>
            <p className="text-gray-medium mb-8 leading-relaxed">
              From AI receptionists that never miss a lead to foot-traffic measurement that proves real-world impact,
              we deliver advertising that drives actual customers — not just impressions.
            </p>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-8">
              {[
                { num: "100+", label: "Happy Clients" },
                { num: "24/7", label: "AI Support" },
                { num: "372%", label: "Avg. ROI Increase" },
                { num: "60+", label: "Directory Listings" }
              ].map((stat, idx) => (
                <div key={idx} className="text-center">
                  <div className="text-3xl font-bold text-orange-primary">{stat.num}</div>
                  <div className="text-sm text-gray-medium">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex justify-center">
              <Link to="/contact" className="btn-primary">
                Get in Touch <ArrowRight size={18} className="inline ml-2" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
